import { Icon } from '@coop/components';
import { HeartFillIcon, HeartIcon } from '@coop/icons';

import type { MenuNode } from '../../../../common/hooks/useMenuState';

import { useFavoriteProductsQuery } from '../../../../common/hooks/useFavoriteProducts';
import styles from './FavoriteProductsSideMenuItemBody.module.scss';

const FavoriteProductsSideMenuItemBody = (props: { node: MenuNode }) => {
    const { data: favoriteProducts } = useFavoriteProductsQuery();

    const hasFavorites = favoriteProducts && favoriteProducts.length > 0;

    return (
        <div className={styles.ItemBody}>
            <span>{`${props.node.name}`}</span>
            <div className={styles.Icon}>
                <Icon
                    icon={hasFavorites ? <HeartFillIcon /> : <HeartIcon />}
                    size="small"
                    aria-hidden
                />
            </div>
        </div>
    );
};

export default FavoriteProductsSideMenuItemBody;
